
export default {
    // components:{    },
    data(){
        return {
            strCurrentTab:'',
        }
    },
    methods:{
        tabChange(strTabId){

        },
		OnTabChange(strTabId){
			let url = new URL(location);
			url.searchParams.set('tab',strTabId);
			this.$router.replace({path: url.search});
			// console.log(strTabId)
		},        
    },
    mounted(){
        let url = new URL(location);
        if(url.searchParams.has('tab'))
            this.strCurrentTab = url.searchParams.get('tab');        
    }
}